import { getApiPath } from '@/shared/api/constants';

const PATHOLOGY_API_NAME = 'pathology';
const ACT = '/act';
const AUDIO = '/audio';
const PROCESS = '/process';
const SIGN = '/sign';

const PATHOLOGY_API = getApiPath(PATHOLOGY_API_NAME);

/* autopsy-act-controller */
export const AUTOPSY_ACT = PATHOLOGY_API + ACT;
export const AUTOPSY_ACT_BY_ID = (id: string) => AUTOPSY_ACT + `/${id}`;
export const AUTOPSY_ACT_AUDIO = (id: string) => AUTOPSY_ACT_BY_ID(id) + AUDIO;
export const AUTOPSY_ACT_PROCESS = (id: string) => AUTOPSY_ACT_BY_ID(id) + PROCESS;
export const AUTOPSY_ACT_SIGN = (id: string) => AUTOPSY_ACT_BY_ID(id) + SIGN;
